import { fork } from 'redux-saga/effects';
import ReportGateway from '~apis/report';

import { RootSagaReturnType } from '~types/saga';
import watchGetSalesReportListing from './getSalesReportListing';
import watchGetSalesReportCardSummary from './getSalesReportCardSummary';
import watchGetSalesReportExport from './getSalesReportExport';
import watchGetInventoryReportCardSummary from './getInventoryReportCardSummary';
import watchGetInventoryReceivedReportListing from './getInventoryReceivedReportListing';
import watchGetInventoryDeliveredReportListing from './getInventoryDeliveredReportListing';
import watchGetInventoryBranchReportListing from './getInventoryBranchReportListing';
import watchGetInventoryReceivedReportExport from './getInventoryReceivedReportExport';
import watchGetInventoryDeliveredReportExport from './getInventoryDeliveredReportExport';
import watchGetInventoryBranchReportExport from './getInventorBranchReportExport';

export default (api: ReportGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetSalesReportListing, api);
        yield fork(watchGetSalesReportCardSummary, api);
        yield fork(watchGetSalesReportExport, api);
        yield fork(watchGetInventoryReportCardSummary, api);
        yield fork(watchGetInventoryReceivedReportListing, api);
        yield fork(watchGetInventoryDeliveredReportListing, api);
        yield fork(watchGetInventoryBranchReportListing, api);
        yield fork(watchGetInventoryReceivedReportExport, api);
        yield fork(watchGetInventoryDeliveredReportExport, api);
        yield fork(watchGetInventoryBranchReportExport, api);
    }

    return {
        rootSaga,
    };
};
